import { serviceAccountsRoutes } from '@neptune/service-accounts-api';
import { tick } from '@neptune/shared/common-util';
import { OrganizationType } from '@neptune/shared/core-organizations-domain';
import { makeEnterpriseRoute } from '@neptune/shared/enterprise-context-business-logic';
import { convertRouteName, isEnterpriseRouteName } from '@neptune/shared/enterprise-context-util';
import { navigateTo } from '@neptune/shared/routing-business-logic';
import { AppRoute } from '@neptune/shared/routing-domain';

import { getContextOrganization } from 'state/selectors-global';

const mainRoute: AppRoute = {
  name: 'organization',
  path: '/-/organization',
  onlyLoggedUser: true,
};

const activityRoute: AppRoute = {
  name: 'organization.activity',
  path: '~/:organizationName/-/activity',
  onlyLoggedUser: true,
  canActivate:
    () =>
    ({ name, params }) => {
      return Promise.reject({
        redirect: {
          name: convertRouteName('organization.projects', isEnterpriseRouteName(name)),
          params,
        },
      });
    },
};

const peopleRoute: AppRoute = {
  name: 'organization.people',
  path: '~/:organizationName/-/people',
  onlyLoggedUser: true,
};

const projectsRoute: AppRoute = {
  name: 'organization.projects',
  path: '~/:organizationName/-/projects',
  onlyLoggedUser: true,
};

const settingsRoute: AppRoute = {
  name: 'organization.settings',
  path: '~/:organizationName/-/settings',
};

const workspaceRoute: AppRoute = {
  name: 'workspace',
  path: '/-/workspace/:organizationName',
  onlyLoggedUser: true,
  canActivate:
    () =>
    ({ name, params }) => {
      return Promise.reject({
        redirect: {
          name: convertRouteName('organization.projects', isEnterpriseRouteName(name)),
          params,
        },
      });
    },
};

const onboardingRoute: AppRoute = {
  name: 'organization.onboarding',
  path: '~/:organizationName/-/onboarding',
  onlyLoggedUser: true,
  onActivate(dispatch, getState) {
    return () => {
      tick(() => {
        const organization = getContextOrganization(getState());
        const isTeamOrganization = organization?.organizationType === OrganizationType.team;
        return isTeamOrganization
          ? dispatch(
              navigateTo(
                'workspace',
                {
                  organizationName: organization?.name,
                },
                {
                  forceContext: OrganizationType.team,
                },
              ),
            )
          : dispatch(
              navigateTo('home', {
                forceContext: OrganizationType.individual,
              }),
            );
      });
    };
  },
};

export default [
  mainRoute,
  activityRoute,
  peopleRoute,
  projectsRoute,
  settingsRoute,
  workspaceRoute,

  {
    ...makeEnterpriseRoute(mainRoute),
    path: '/o/-/organization',
  },
  makeEnterpriseRoute({
    ...activityRoute,
    path: '~/o/:organizationName/-/activity',
  }),
  makeEnterpriseRoute({
    ...peopleRoute,
    path: '~/o/:organizationName/-/people',
  }),
  makeEnterpriseRoute({
    ...projectsRoute,
    path: '~/o/:organizationName/-/projects',
  }),
  makeEnterpriseRoute({
    ...settingsRoute,
    path: '~/o/:organizationName/-/settings',
  }),
  makeEnterpriseRoute({
    ...workspaceRoute,
    path: '~/o/workspace/:organizationName',
  }),
  makeEnterpriseRoute({
    ...onboardingRoute,
    path: '~/o/:organizationName/-/onboarding',
  }),
  ...serviceAccountsRoutes,
];
